import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/shopify-enterprise-generic/Templates/SearchPage.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTilessubtitles from 'Stores/_default-store/Templates/facetTiles/subtitles.rt'
import { SearchHeader } from 'Components'
import { SearchResult } from 'Components'
import { FacetPanel } from 'Components'
import { FacetBar } from 'Components'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonAdaptable from 'Stores/_default-store/Templates/searchBox/dialogButtonAdaptable.rt'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchcollapsibleVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/collapsibleVehicleWidget.rt'
import { RequestPanel } from 'Components'
import TemplateHomeWheelTireBar from 'Stores/_default-store/Templates/HomeWheelTireBar.rt'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/_default-store/Templates/fitmentSearch/singleVehicleGarage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchcollapsibleVerifyFitment from 'Stores/_default-store/Templates/fitmentSearch/collapsibleVerifyFitment.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/shopify-enterprise-generic/Templates/product/relatedItems.rt'
import { BuyItemsTogether } from 'Components'
import TemplateproductboughtTogether from 'Stores/_default-store/Templates/product/boughtTogether.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialogVehicleSpecs from 'Stores/_default-store/Templates/FacetDialogVehicleSpecs.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/_default-store/Templates/fitmentSearch/dialog.rt'
import { AutoSyncVisualizationDialog } from 'Components'
import TemplatefitmentSearchautoSyncVisualizationDialog from 'Stores/_default-store/Templates/fitmentSearch/autoSyncVisualizationDialog.rt'

export const compMap = {
  SearchPage,
FacetTiles,
SearchHeader,
SearchResult,
FacetPanel,
FacetBar,
SearchBoxDialogButton,
VehicleWidget,
RequestPanel,
SearchBox,
Garage,
SingleVehicleGarage,
VerifyFitment,
FitmentTable,
RelatedItems,
BuyItemsTogether,
FacetDialog,
SearchBoxDialog,
VehicleWidgetDialog,
AutoSyncVisualizationDialog
}
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'facetTiles/subtitles': TemplatefacetTilessubtitles,
'searchBox/dialogButtonAdaptable': TemplatesearchBoxdialogButtonAdaptable,
'fitmentSearch/collapsibleVehicleWidget': TemplatefitmentSearchcollapsibleVehicleWidget,
'HomeWheelTireBar': TemplateHomeWheelTireBar,
'SearchBox': TemplateSearchBox,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/collapsibleVerifyFitment': TemplatefitmentSearchcollapsibleVerifyFitment,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'product/relatedItems': TemplateproductrelatedItems,
'product/boughtTogether': TemplateproductboughtTogether,
'FacetDialogVehicleSpecs': TemplateFacetDialogVehicleSpecs,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'fitmentSearch/autoSyncVisualizationDialog': TemplatefitmentSearchautoSyncVisualizationDialog
};